import { getMacroTokenRanges } from "authoring/routes/macro/lib/macro-token-utils"
import { buildChipHtmlForToken, stripChipHtml } from "authoring/routes/macro/lib/macro-chip-utils"

/**
 * Converts $TOKEN$ patterns in amends content to chip HTML for display in the editor.
 * This makes macro references visible as styled chips while editing.
 */
export function buildEditableAmendsMacroValue(content, macroMap) {
    if (!content || !macroMap || !Object.keys(macroMap).length) return content

    const value = `${content}`
    const ranges = getMacroTokenRanges(value)
    if (!ranges.length) return value

    let output = ""
    let cursor = 0
    for (const range of ranges) {
        output += value.slice(cursor, range.start)
        output += buildChipHtmlForToken(range.tokenId, macroMap)
        cursor = range.end
    }
    output += value.slice(cursor)
    return output
}

/**
 * Strips chip HTML back to $TOKEN$ format for persistence.
 * This is the inverse of buildEditableAmendsMacroValue.
 */
export function normalizeAmendsMacroValue(content) {
    return stripChipHtml(content)
}
